import {ExternalAppealProviderModel} from './ExternalAppealProviderModel.js';
import {ExternalAppealPatientModel} from './ExternalAppealPatientModel.js';
import {ExternalAppealHealthPlanModel} from './ExternalAppealHealthPlanModel.js';
import {ExternalAppealDocumentModel} from './ExternalAppealDocumentModel.js';
import {ExternalAppealAuthorizedRepModel} from './ExternalAppealAuthorizedRepModel.js';
import {EXTERNAL_APPEALS_STATUSES} from "@/utils/constants.js";

export class ExternalAppealModel {
    constructor(data = {}) {
        this.appealId = data.appealId ?? null;
        this.internalId = data.internalId ?? null;
        this.appealStatus = data.appealStatus ?? EXTERNAL_APPEALS_STATUSES.InfoNeeded;
        this.appealOutcome = data.appealOutcome ?? null;
        this.appealCategory = data.appealCategory ?? null;
        this.isExpedited = data.isExpedited ?? false;
        this.isExternalAppealOnly = data.isExternalAppealOnly ?? false;
        this.isForwardingAuthorized = data.isForwardingAuthorized ?? null;
        this.expeditedReason = data.expeditedReason ?? null;
        this.summaryOfAppeal = data.summaryOfAppeal ?? null;
        this.internalAppealStatus = data.internalAppealStatus ?? null;
        this.internalAppealDenialDate = data.internalAppealDenialDate ?? null;
        this.signature = data.signature ?? null;
        this.signatureDate = data.signatureDate ?? null;
        this.signatureRelationship = data.signatureRelationship ?? null;
        this.reviewOrganization = data.reviewOrganization ?? null;
        this.assignedInvestigator = data.assignedInvestigator ?? null;
        this.iroAt = data.iroAt ?? null;
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;

        // Instantiate related models if present
        this.provider = new ExternalAppealProviderModel(data.provider ?? {});
        this.patient = new ExternalAppealPatientModel(data.patient ?? {});
        this.healthPlan = new ExternalAppealHealthPlanModel(data.healthPlan ?? {});
        this.documents = Array.isArray(data.documents) ? data.documents.map(d => new ExternalAppealDocumentModel(d)) : [];
        this.authorizedRep = new ExternalAppealAuthorizedRepModel(data.authorizedRep ?? {});
    }

    toRequestPayload() {
        return {
            appeal: {
                ...this,
                provider: undefined,
                patient: undefined,
                healthPlan: undefined,
                documents: undefined,
                authorizedRep: undefined,
            },
            patient: this.patient.toRequestPayload ? this.patient.toRequestPayload() : {...this.patient},
            healthPlan: this.healthPlan.toRequestPayload ? this.healthPlan.toRequestPayload() : {...this.healthPlan},
            documents: this.documents.map(d => d.toRequestPayload ? d.toRequestPayload() : {type: d.type, url: d.url}),
            authorizedRep: (this.authorizedRep && !this.authorizedRep.isEmpty())
                ? this.authorizedRep.toRequestPayload()
                : null,
            provider: (this.provider && !this.provider.isEmpty())
                ? this.provider.toRequestPayload()
                : null,
        };
    }
}
